export default "__VITE_ASSET__Bn9_RxY6__"